import { isCapacitorPushNative, initIOSPush } from "@/lib/nativePush";

const K = "calofay:push-prompt-state";
const MAX_SHOWS = 3;
const COOLDOWN_MS = 14 * 24 * 3600 * 1000;

function read() {
  try { return JSON.parse(localStorage.getItem(K)) || { count: 0, next_at: 0 }; }
  catch { return { count: 0, next_at: 0 }; }
}
function write(s) { try { localStorage.setItem(K, JSON.stringify(s)); } catch {} }

// "granted" | "denied" | "prompt" | "unsupported"
export async function getPushPermission() {
  if (isCapacitorPushNative()) {
    try {
      const { PushNotifications } = await import("@capacitor/push-notifications");
      const { receive } = await PushNotifications.checkPermissions();
      return receive === "granted" ? "granted" : receive === "denied" ? "denied" : "prompt";
    } catch { return "unsupported"; }
  }
  if (!("Notification" in window)) return "unsupported";
  const p = Notification.permission;
  return p === "default" ? "prompt" : p;
}

export async function shouldShowPushPrompt() {
  const s = read();
  const perm = await getPushPermission();
  if (perm === "granted") {
    // Already allowed (e.g. Android ≤12) — silently register the device token, no dialog.
    if (isCapacitorPushNative()) initIOSPush().catch(() => {});
    if (!s.enabled) write({ ...s, enabled: true });
    return false;
  }
  if (s.enabled || s.count >= MAX_SHOWS || Date.now() < (s.next_at || 0)) return false;
  return perm !== "unsupported";
}

export function markPushShown() {
  const s = read();
  write({ ...s, count: (s.count || 0) + 1 });
}

export function markPushDeclined() {
  write({ ...read(), next_at: Date.now() + COOLDOWN_MS });
}

export function markPushEnabled() {
  write({ ...read(), enabled: true });
}
